import PropTypes from "prop-types"
import React, { useRef, useState } from "react"

const DropdownCheckboxSelect = ({ label, onChange, options, selected }) => {
  const [isOpen, setIsOpen] = useState(false)
  let blurTimeout = useRef()

  const handleBlur = (event) => {
    blurTimeout = setTimeout(() => {
      setIsOpen(false)
    })
  }

  const handleInputChange = (event) => {
    event.target.focus()
    onChange(event)
    setIsOpen(false)
  }

  const handleFocus = (event) => {
    clearTimeout(blurTimeout)
  }

  const renderOption = (option) => {
    const isChecked = Boolean(
      selected.includes(option.value) || selected.includes(option.label)
    )

    return (
      <div className="checkbox my-1" key={option.value}>
        <label>
          <input
            type="checkbox"
            name={option.label}
            id={option.value}
            checked={isChecked}
            onChange={handleInputChange}
            className="cursor-pointer"
          />
          <span tabIndex="-1">{option.label}</span>
        </label>
      </div>
    )
  }

  return (
    <div
      className={"w-full md:w-auto"}
      onFocus={handleFocus}
      onBlur={handleBlur}
    >
      <button
        type="button"
        className={"btn btn-secondary w-full md:w-auto"}
        onClick={() => setIsOpen(!isOpen)}
      >
        {label}
        <div className="flex items-center justify-center">
          <span
            className={`fa-kit pl-2 pt-1 fa-sf-chevron-${
              isOpen ? "up" : "down"
            }`}
            style={{ fontSize: "0.4em" }}
            aria-label={`${isOpen ? "open" : "closed"}`}
            data-testid="open-icon"
          />
        </div>
      </button>
      <div className="absolute">
        {isOpen && (
          <div className="relative z-10 mt-2 rounded-sm border bg-white p-3 shadow-lg">
            {options.map((option) => renderOption(option))}
          </div>
        )}
      </div>
    </div>
  )
}

DropdownCheckboxSelect.propTypes = {
  children: PropTypes.node,
  label: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.array.isRequired,
  selected: PropTypes.array.isRequired,
}

export default DropdownCheckboxSelect
